import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import validator from "validator";
import axios from "../../../api/axios";
import logoimg from "../../../images/logo.png";
import {
  FaRegUser,
  FaRegEnvelope,
  FaKey,
  FaUserCircle,
  FaPhoneAlt,
  FaInfoCircle,
  FaTimes,
  FaCheck,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./Register.css";
import SyncLoader from "react-spinners/SyncLoader";

const REGISTER_URL = "/api/register";
const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;


const Register = () => {
  const decor = {
    textDecoration: "none",
  };

  const [username, setUsername] = useState("");
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [matchPwd, setMatchPwd] = useState(false);
  const [matchFocus, setMatchFocus] = useState(false);
  const [validName, setValidName] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [validMatch, setValidMatch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  let navigate = useNavigate();

  useEffect(() => {
    setValidName(USER_REGEX.test(username));
  }, [username]);

  useEffect(() => {
    setValidMatch(password === matchPwd);
  }, [password, matchPwd]);


  const checkInputs = () => {
    if (!validator.isEmail(email)) {
      setErrMsg("Invalid Email Address");
      return;
    }
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    checkInputs();
    // if button enabled with JS hack
    const v1 = USER_REGEX.test(username);
    if (!v1) {
      setErrMsg("Invalid Entry");
      return;
    }

    if (password.length < 8) {
      setErrMsg("Password must not be less than 8 characters");
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        REGISTER_URL,
        JSON.stringify({
          username,
          first_name: firstname,
          last_name: lastname,
          password,
          email,
          phone,
        }),
        config
      );
      console.log(response?.data);
      console.log(response?.accessToken);
      console.log(JSON.stringify(response));
      navigate("/account-success");
      //clear state and controlled inputs
      //need value attrib on inputs for this
      setUsername("");
      setPassword("");
      setMatchPwd("");
      setEmail("");
      setFirstName("");
      setLastName("");
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 409) {
        setErrMsg("Username Taken");
      } else if (err.response?.status === 422) {
        console.log({ err });
        const firstErrorKey = Object.keys(err.response.data.errors)[0];
        const firstErrorMsg = err.response.data.errors[firstErrorKey][0];
        console.log({ hey: "sd", firstErrorMsg });
        setErrMsg(firstErrorMsg);

      } else {
        setErrMsg("Registration Failed");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-wrapper">
        <p className={errMsg ? "errmsg" : "offscreen"} arial-live="assertive">
          {errMsg}
        </p>
        <form onSubmit={(e) => handleSubmit(e)} className="login-form">
          <div className="login-cancel">
            <Link to="/" className="">
              <FaTimes className="login-cancel-icon" />
            </Link>
          </div>
          <Link to="/">
            <div className="login-img-div">
              <img className="logo-img" src={logoimg} alt="" />
            </div>
          </Link>
          <h3>Register</h3>
          <div className="login-info-wrap log">
            <label for="myfile" className="login-name">
              Username *
              <FaCheck className={validName ? "valid" : "hide"} />
              <FaTimes
                className={validName || !username ? "hide" : "invalid"}
              />
            </label>
            <div className="input-style">
              <div className="input-icon">
                <FaUserCircle className="userprofile" />
              </div>
              <input
                type="text"
                id="username"
                onChange={(e) => setUsername(e.target.value)}
                value={username}
                arial-invalid={validName ? "false" : "true"}
                arial-describeby="uidnote"
                required
                placeholder="Your Username"
              />
            </div>
          </div>
          <div className="login-info-wrap log">
            <label for="myfile" className="login-name">
              First Name *
            </label>
            <div className="input-style">
              <div className="input-icon">
                <FaRegUser className="userprofile" />
              </div>
              <input
                type="text"
                id="firstname"
                onChange={(e) => setFirstName(e.target.value)}
                value={firstname}
                required
                placeholder="Your Firstname"
              />
            </div>
          </div>
          <div className="login-info-wrap log">
            <label for="myfile" className="login-name">
              Last Name *
            </label>
            <div className="input-style">
              <div className="input-icon">
                <FaRegUser className="userprofile" />
              </div>
              <input
                type="text"
                id="lastname"
                onChange={(e) => setLastName(e.target.value)}
                value={lastname}
                required
                placeholder="Your Lastname"
              />
            </div>
          </div>
          <div className="login-info-wrap log">
            <label for="myfile" className="login-name">
              Email *
            </label>
            <div className="input-style">
              <div className="input-icon">
                <FaRegEnvelope className="userprofile" />
              </div>
              <input
                type="email"
                id="email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                required
                placeholder="Your Email"
              />
            </div>
          </div>
          <div className="login-info-wrap log">
            <label for="myfile" className="login-name">
              Phone Number *
            </label>
            <div className="input-style">
              <div className="input-icon">
                <FaPhoneAlt className="userprofile" />
              </div>
              <input
                type="tel"
                id="phone"
                onChange={(e) => setPhone(e.target.value)}
                value={phone}
                required
                name="telphone"
                maxlength="11"
                placeholder="Phone Number"
              />
            </div>
          </div>
          <div className="login-info-wrap log">
            <label for="myfile" className="login-name">
              Password *
            </label>
            <div className="input-style">
              <div className="input-icon">
                <FaKey className="userprofile" />
              </div>
              <input
                type="password"
                id="password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                required
                placeholder="Your Password"
                aria-describedby="pwdnote"
              />
            </div>
          </div>
          <div className="login-info-wrap log">
            <label for="myfile" className="login-name">
              Confirm Password *
              <FaCheck className={validMatch && matchPwd ? "valid" : "hide"} />
              <FaTimes
                className={validMatch || !matchPwd ? "hide" : "invalid"}
              />
            </label>
            <div className="input-style">
              <div className="input-icon">
                <FaKey className="userprofile" />
              </div>
              <input
                type="password"
                id="pwd"
                onChange={(e) => setMatchPwd(e.target.value)}
                required
                placeholder="Confirm Password"
                aria-invalid={validMatch ? "false" : "true"}
                aria-describedby="confirmnote"
                onFocus={() => setMatchFocus(true)}
                onBlur={() => setMatchFocus(false)}
              />
              <p
                id="confirmnote"
                className={
                  matchFocus && !validMatch ? "instructions" : "offscreen"
                }
              >
                <FaInfoCircle />
                Must match the first password input field.
              </p>
            </div>
          </div>
          {isLoading ? (
            <div className="loading">
              <SyncLoader color={"#098FD2"} loading={isLoading} size={10} />
            </div>
          ) : (
            <div className="login-btn">
              <button type="submit" className="login-button">
                Register
              </button>
            </div>
          )}

          <div className="exist-acc">
            <p>Already have an account?</p>

            <Link style={decor} to="/login">
              <li className="home reg"> Login</li>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
